import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/header';
import RightSidebar from '../components/views/RightSidebar'; 
// Added API Services
import brandService from '../api/brandService';
import postTypeService from '../api/postTypeService';
import userService from '../api/userService';
import { useEffect } from 'react';

const Dashboard = ({ 
  isDark, 
  setIsDark, 
  user, 
  onLogout, 
  onFilterChange, 
  activeFilters,    // This must be passed from App.js to Dashboard
  onDataLoaded,     // This must be passed from App.js to Dashboard
  rawData,
  onTaskClick,
  onSave,           
  onDelete,         
  selectedTask,
  isRightSidebarOpen,
  setIsRightSidebarOpen 
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [dropdownData, setDropdownData] = useState({
    brands: [],
    postTypes: [],
    users: []
  });
  const location = useLocation();

  const getActivePageName = () => {
    const path = location.pathname.split('/')[1];
    if (!path || path === "schedule") return "Schedule";
    return path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, ' ');
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const [bRes, tRes, uRes] = await Promise.all([
          brandService.getAllBrands(),
          postTypeService.getActiveTypes(),
          userService.getMinimalUsers()
        ]);
        
        // Extracting data based on your API structures
        const brands = Array.isArray(bRes) ? bRes : bRes?.data || [];
        const postTypes = Array.isArray(tRes) ? tRes : tRes?.data || [];
        const users = uRes?.data || (Array.isArray(uRes) ? uRes : []);

        setDropdownData({
          brands: brands.filter(b => b.is_active === 1),
          postTypes: postTypes,
          users: users.filter(u => u.is_active === 1 || u.is_active === true)
        });
      } catch (err) {
        console.error("Dashboard failed to load config data", err);
      }
    };
    fetchConfigs();
  }, []);
  return (
    <div className={`flex h-screen font-sans transition-colors duration-300 ${
      isDark ? 'bg-slate-950 text-slate-300' : 'bg-white text-slate-600'
    }`}>
      
      <Sidebar 
        isOpen={isSidebarOpen} 
        setIsOpen={setIsSidebarOpen} 
        isDark={isDark} 
        user={user}
        rawData={rawData} 
        onFilterChange={onFilterChange} 
        brands={dropdownData.brands}
        postTypes={dropdownData.postTypes}
        users={dropdownData.users}
      />
      
      <div className="flex-1 flex flex-col relative">
        <Header 
          activePage={getActivePageName()} 
          setIsSidebarOpen={setIsSidebarOpen} 
          isDark={isDark}
          setIsDark={setIsDark}
          user={user}
          onLogout={onLogout}
          onTaskClick={onTaskClick} 
        />

        <main className={`flex-1 relative min-h-0 transition-colors duration-300 ${
          isDark ? 'bg-slate-900' : 'bg-white'
        }`}>
          <div className={`w-full h-full rounded-tl-[24px] lg:rounded-tl-[70px] flex flex-col shadow-[inset_4px_4px_15px_rgba(0,0,0,0.02)] transition-all duration-300 ${
            isDark 
              ? 'bg-slate-800 border-t border-l border-slate-700' 
              : 'bg-[#f1f5f9] border-t border-l border-slate-200'
              
          }`}>
            <div className="flex-1 overflow-y-auto pt-8 px-4 md:px-8 pb-12 custom-scrollbar">
               <Outlet context={{ 
                 isDark, 
                 onTaskClick, 
                 activeFilters, 
                 onDataLoaded,
                 brands: dropdownData.brands,
                 postTypes: dropdownData.postTypes,
                 users: dropdownData.users
               }} />
            </div>
          </div>
        </main>
      </div>

      <RightSidebar 
        isOpen={isRightSidebarOpen} 
        onClose={() => setIsRightSidebarOpen(false)} 
        post={selectedTask}
        isDark={isDark}
        user={user}
        onSave={onSave}
        onDelete={onDelete}
        onUpdate={handleRefresh}
        brands={dropdownData.brands}
        postTypes={dropdownData.postTypes}
        users={dropdownData.users} 
      />
    </div>
  );
};

export default Dashboard;